<div [ngClass]="{
  'page-loading': _pageLoading(),
  'page-loaded': _pageLoaded(),
  'app-initialized': _appInitialized()
}">
  <div id="page-preloader" emSidebarTarget [hidden]="_pageLoaded()">
    <div>
      <div>
        <op-ellipsis></op-ellipsis>
      </div>
    </div>
  </div>
  <ui-view></ui-view>
</div>
